// ── Iyanna Foundation — Program Registry ────────────────────────────────
// Kila programu inaelezwa hapa kama DATA, si code. Ukitaka kuongeza
// programu mpya kesho, ongeza kitu kimoja kwenye orodha hii — kurasa
// zote (wanachama, ripoti, session, AI) zitajijenga zenyewe.
//
// MUHIMU: bloku ya 'chess' na 'lifeskills' ni ZILEZILE kwa programu
// zote. Ndio maana data inalinganishwa kwa urahisi na AI inaelewa
// programu mpya bila kufundishwa upya.

export const MEMBER_TYPES = {
  mtoto:     { label: 'Mtoto',      plural: 'Watoto',   identify: 'school', identifyLabel: 'Shule' },
  kijana:    { label: 'Kijana',     plural: 'Vijana',   identify: 'centre', identifyLabel: 'Kituo' },
  mtu_mzima: { label: 'Mtu Mzima',  plural: 'Watu Wazima', identify: 'area', identifyLabel: 'Eneo / Mtaa' },
  mzazi:     { label: 'Mzazi',      plural: 'Wazazi',   identify: 'area',   identifyLabel: 'Eneo / Mtaa' },
};

export const PROGRAMS = [
  {
    id: 'chess',
    name: 'Programu ya Chess',
    short: 'Chess Clubs',
    tagline: 'Chess clubs za mashuleni na mtaani — watoto na watu wazima',
    color: '#14452F',
    accent: '#1F6B45',
    icon: 'chess',
    memberTypes: ['mtoto', 'mtu_mzima'],
    clubTypes: ['shule', 'mtaani'],
    // Bloku za ripoti binafsi, kwa kila aina ya mwanachama
    blocks: {
      mtoto:     ['chess', 'lifeskills'],
      mtu_mzima: ['chess', 'lifeskills'],
    },
  },
  {
    id: 'msaada',
    name: 'Msaada kwa Watoto na Wazazi',
    short: 'Msaada',
    tagline: 'Watoto na wazazi tunaowasaidia — shule, nyumbani, biashara',
    color: '#E07A2E',
    accent: '#C2410C',
    icon: 'parents',
    memberTypes: ['mtoto', 'mzazi'],
    clubTypes: ['shule', 'mtaani'],
    blocks: {
      mtoto: ['chess', 'lifeskills', 'shule', 'nyumbani'],
      // Kwa wazazi: lifeskills na microfinance ndio msingi.
      // Chess ni HIARI — inaonekana tu kwa mzazi aliyewekwa alama
      // "anajifunza chess". Wasiojifunza hawaulizwi maswali ya chess.
      mzazi: ['lifeskills', 'microfinance', 'chess', 'biashara', 'binafsi'],
    },
    blockOptions: {
      mzazi: {
        chess: { onlyIf: 'learnsChess', optional: true },
      },
    },
  },
  {
    id: 'usariver',
    name: 'Usa River Youth Development Centre',
    short: 'Usa River YDC',
    tagline: 'Vijana wa kituo — chess na lifeskills',
    color: '#4527A0',
    accent: '#5E35B1',
    icon: 'seedling',
    memberTypes: ['kijana'],
    clubTypes: ['kituo'],
    defaultClub: 'Usa River YDC Chess Club',
    blocks: {
      kijana: ['chess', 'lifeskills', 'kijana'],
    },
  },
];

export const CLUB_TYPES = {
  shule:  { label: 'Club ya Shule',   locationLabel: 'Jina la Shule' },
  mtaani: { label: 'Club ya Mtaani',  locationLabel: 'Mtaa / Eneo' },
  kituo:  { label: 'Club ya Kituo',   locationLabel: 'Jina la Kituo' },
};

export function getProgram(id) {
  return PROGRAMS.find(p => p.id === id) || null;
}

// ══ MAJINA YANAYOWEZA KUBADILISHWA ═══════════════════════════════════
// Muundo wa programu (bloku, aina za wanachama, kanuni) uko kwenye code
// na hauguswi. Lakini JINA, maelezo na rangi ni ya taasisi — mnaweza
// kuyabadilisha wakati wowote kutoka "Majina ya Programu" bila developer.
//
// Vitu vinavyoweza kubadilishwa: name, short, tagline, color, accent.
// Vitu VISIVYOBADILIKA: id, blocks, memberTypes, clubTypes — hivi ndivyo
// vinavyoshikilia data yote iliyokwisha kusanywa.

export const EDITABLE_FIELDS = ['name', 'short', 'tagline', 'color', 'accent'];

const listeners = new Set();

export function subscribePrograms(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// Inabadilisha vitu vilivyo ndani ya PROGRAMS moja kwa moja, hivyo kila
// ukurasa unaosoma `program.name` unaona jina jipya bila kuunganishwa upya.
export function applyProgramOverrides(overrides = []) {
  overrides.forEach(o => {
    const p = PROGRAMS.find(x => x.id === o.id);
    if (!p) return;
    EDITABLE_FIELDS.forEach(f => {
      if (o[f] !== undefined && o[f] !== null && o[f] !== '') p[f] = o[f];
    });
  });
  listeners.forEach(fn => { try { fn(); } catch (e) { /* noop */ } });
}

// Majina ya asili (kwa kitufe cha "rudisha jina la awali")
export const DEFAULT_NAMES = PROGRAMS.reduce((acc, p) => {
  acc[p.id] = { name: p.name, short: p.short, tagline: p.tagline, color: p.color, accent: p.accent };
  return acc;
}, {});

// Bloku zinazotumika kwa mwanachama fulani ndani ya programu fulani.
// Ikiwa aina haijaelezwa, tunarudi kwenye bloku za msingi (chess +
// lifeskills) — hivyo programu mpya haitawahi kuvunjika.
export function blocksFor(programId, memberType) {
  const p = getProgram(programId);
  if (!p) return ['chess', 'lifeskills'];
  return p.blocks?.[memberType] || ['chess', 'lifeskills'];
}

// Programu inaweza kubadilisha tabia ya bloku kwa aina fulani ya mwanachama
// — mfano: chess ni HIARI kwa wazazi. Bloku yenyewe haibadiliki; ni sharti
// la kuionyesha ndilo linalobadilika.
export function blockOverride(programId, memberType, blockId) {
  const p = getProgram(programId);
  return p?.blockOptions?.[memberType]?.[blockId] || null;
}
